<template>
    <div class="row vert-offset-top-1">
        <div v-show="component === null || component.length == 0" class="col s12 l10 offset-l1">
            <div class="card grey lighten-4 col s12 vert-offset-top-1 padding-top-half flow-text">
                <h4>What offense(s) are you Reporting?</h4>
                <div class="card-content col s12 left-align">
                    <div class="row vert-offset-bottom-1">
                        <div class="col s12 no-padding">
                            <div class="col s12 m10 offset-m1 padding-top-half padding-bottom-half no-padding flow-text grey-border border-bottom-1 border-lighten-2 padding-bottom-1" >
                                <form @submit.prevent="" class="row col s12 no-padding">
                                  <p v-for="(item, index) in offences"
                                       :key="index">
                                        <label>
                                            <input type="checkbox" :value="item.key"
                                                   :key="index" @click="selectOffence(index)" />
                                            <span v-html="item.name" class="bold black-text"></span>
                                        </label>
                                    </p>

                                  <ul>
                                    <li v-show="offences.length==0 && data_collected==true" >
                                      network error, check connection and try again!!
                                    </li>
                                  </ul>
                                </form>
                            </div>
                            <div class="col s4 offset-s8 vert-offset-top-1">
                                <button type="submit" v-on:click="loadSearchBar" id="submit_button" class="btn btn-large grey darken-2 white-text col s12" :disabled='counter <= 0' >
                                    next
                                </button>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
        <component v-bind:is="component"></component>
    </div>

</template>

<script>
    import SearchBarSelect from "@/components/SearchBarSelect"
    import http from "../http-common";
  //  import {mapState} from "vuex";
    export default {
        name:"ReportingComponent",
        components:{
            'SearchBarSelect': SearchBarSelect,
        },
        data () {
            return{
                data_collected:false,
                offences:[],
                checked:[],
                enableDisable: true,
                component:"",
                list_offenses : [],
                counter : 0
            }
        },
        methods:{
            getOffences: function() {

                this.$store.dispatch("START_PROCESSING");
                return new Promise(resolve => {
                    http({
                        url: "/offences/list/select",
                        data : {
                            offences : this.offences,
                        },
                        method: "POST",
                        timeout: 30000 })
                        .then(resp => {

                          this.data_collected=true;
                           //console.log("Response:" + JSON.stringify(resp));
                           //console.log("token:" + JSON.stringify(resp.data));
                            this.offences = resp.data.data;
                            this.$store.dispatch("STOP_PROCESSING");
                           //console.log("offences: " + JSON.stringify(this.offences));

                            resolve(resp);
                        })
                        .catch(response => {
                           //console.log("ErrResponse: " + JSON.stringify(response));
                            this.$store.dispatch("STOP_PROCESSING");
                            this.$store.dispatch("GET_MESSAGES", response.data.messages);
                            this.getOffences();
                        });
                });
            },
            selectOffence: function (_index)
            {
                var _selected_offence = this.offences[_index];
               //console.log("SELECTED OFFENCE: " + JSON.stringify(_selected_offence));
                if(typeof  _selected_offence === "undefined" || _selected_offence === null)
                {
                    return false;
                }

                if(this.list_offenses.indexOf(_selected_offence.key) >= 0)
                {
                    this.counter--;
                   //console.log("Remove");
                    this.list_offenses.splice(this.list_offenses.indexOf(_selected_offence.key), 1);
                }
                else
                {
                    this.counter++;
                   //console.log("Add");
                    this.list_offenses.push(_selected_offence.key);
                }
            },
            loadSearchBar: function()
            {
                this.$store.dispatch('SET_SELECTED_OFFENSES', this.list_offenses);
                this.component = 'SearchBarSelect';
            }


        },
        computed: {
            enableDisabled: function() {
                /*if(typeof this.list_offenses === "undefined" || this.list_offenses === null || this.list_offenses.length === 0)
                 return false;*/
                if(this.counter <= 0)
                    return false;

                return true;
            },
            checkboxinput(){
               return this.$store.state.offences;
            }

        },

        created(){
            this. getOffences();
        }






    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
